import React from "react";
import "./Rightfooter.css";
import Logo from "../Logo/logo1.png"; // ya png use karo

const Rightfooter: React.FC = () => {
  return (
    <footer className="custom-footer">

      <div className="footer-container">

        {/* ===== COLUMN 1 ===== */}
        <div className="footer-col">
          <img src={Logo} alt="Courier Addaa" className="footer-logo" />
          <p>
            <strong>Right Express</strong> Reliable delivery services offering fast shipping, real-time tracking.
            
          </p>
        </div>

        {/* ===== COLUMN 2 ===== */}
        <div className="footer-col">
          <h5>Our Divisions</h5>
          <ul>
            <li>What We Do</li>
            <li>Request a Freight</li>
            <li>Track & Trace</li>
            <li>About Us</li>
            <li>Package Plan</li>
          </ul>
        </div>

        {/* ===== COLUMN 3 ===== */}
        <div className="footer-col">
          <h5>Our Services</h5>
          <ul>
            <li>Road Freight</li>
            <li>Drone Freight</li>
            <li>Ocean Freight</li>
            <li>Rail Freight</li>
            <li>Air Freight</li>
          </ul>
        </div>

        {/* ===== COLUMN 4 ===== */}
        <div className="footer-col">
          <h5>Industry Sectors</h5>
          <ul>
            <li>What We Do</li>
            <li>Request a Freight</li>
            <li>Track & Trace</li>
            <li>Our Team</li>
            <li>Contact Us</li>
          </ul>
        </div>

        {/* ===== COLUMN 5 ===== */}
        <div className="footer-col">
          <h5>Get in Touch</h5>
          <p>
            <i className="fas fa-map-marker-alt"></i>
            SHOP NO- E-17,VRAJDHAM-1, NEAR UJALA CIRCLE SARKHEJ, AHMEDABAD-382210
          </p>
          <p>
            <i className="fas fa-phone-alt"></i> +91-8949598887
          </p>
          <p>
            <i className="far fa-envelope"></i>{" "}
            <a href="mailto:courieraddaa@gmail.com">
              info@rightexpress.in
            </a>
          </p>
        </div>

      </div>

      {/* ===== COPYRIGHT STRIP ===== */}
      <div className="footer-bottom">
        <p>© 2022  Right Express PVT.LTD. | All rights reserved</p>

        <span>
          Powered by{" "}
          <a href="https://www.neotechnet.com" target="_blank" rel="noreferrer">
            Neotech IT Services
          </a>
        </span>

        <div className="footer-social">
          <a href="https://facebook.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-facebook-f"></i>
          </a>
          <a href="https://x.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-x-twitter"></i>
          </a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-instagram"></i>
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-linkedin-in"></i>
          </a>
          <a href="https://youtube.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-youtube"></i>
          </a>
          <a href="https://wa.me/918949598887" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-whatsapp"></i>
          </a>
        </div>
      </div>

    </footer>
  );
};

export default Rightfooter;
